<div *ngIf="map" class="map-gp-vfk-panel" [ngClass]="{ 'map-gp-vfk-panel--opened': open }">

  <h2 style="padding-right: 40px;">Obsah VFK souboru</h2>

  <a class="button toggle-button" (click)="open = !open"><i class="fa" [ngClass]="{ 'fa-angle-double-up': open, 'fa-angle-double-down': !open }"></i></a>

  <div *ngIf="open">
    <div [loading]="!vfk">

      <fieldset>
        <legend>Vrstvy</legend>
        <div *ngFor="let group of groups" (click)="group.enabled=!group.enabled" class="mb-5">
          <gmt-checkbox [gmtChecked]="group.enabled"></gmt-checkbox> {{ group.title }}
        </div>
      </fieldset>

      <div class="flexbox-container flex-centered">
        <gmt-button [clickAction]="show" [gmtDisabled]="!canShowMap">Zobrazit</gmt-button>
      </div>
    </div>
  </div>
</div>
